import React from 'react';
import { Drawer, Iconfont } from '@umu/umu-design';
import { createRoot } from 'react-dom/client';
export interface IDrawerConfig {
    title?: string | JSX.Element;
    content?: JSX.Element | string;
    closable?: boolean;
    hideTitle?: boolean;
    hideBackIcon?: boolean;
    showCloseIcon?: boolean;
    renderPrefixIcon?: () => JSX.Element;
    renderSuffixIcon?: () => JSX.Element;
}
interface IDrawOpenInfo {
    link?: string;
    config?: IDrawerConfig;
}

export const onDrawOpenByLink = (info: IDrawOpenInfo): { eleId: string; onClose: () => void } | undefined => {
    // 向body中添加一个div 同时将 drawerComponent 渲染在div中
    const eleId = `drawer-element-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
    const { link, config = {} } = info;
    const {
        content = '',
        closable = false,
        hideTitle = false,
        hideBackIcon = false,
        showCloseIcon = false,
        renderPrefixIcon,
        renderSuffixIcon,
    } = config;
    const isLink = !!link;
    const ele = document.createElement('div');
    ele.id = eleId;
    document.body.appendChild(ele);
    const root = createRoot(document.querySelector(`#${eleId}`)!);
    const onClose = () => {
        root.unmount();
    };
    const onBack = () => {
        onClose();
    };
    const drawerHeard = () => {
        if (!hideTitle) {
            return (
                <div className="drawer-element-header">
                    <div className="drawer-element-header-left">
                        {!hideBackIcon && (
                            <Iconfont type="Bigback" className="back-drawer icon-drawer" onClick={onBack} />
                        )}
                        {renderPrefixIcon?.()}
                    </div>
                    <div className="drawer-element-header-title" id={`${eleId}Title`}>
                        {config?.title}
                    </div>
                    <div className="drawer-element-header-right">
                        {showCloseIcon && (
                            <Iconfont type="Close" className="close-drawer icon-drawer" onClick={onClose} />
                        )}
                        {renderSuffixIcon?.()}
                    </div>
                </div>
            );
        }
        return '';
    };

    root.render(
        <Drawer
            title={drawerHeard()}
            closable={closable}
            style={{ maxWidth: '7rem', zIndex: 4000 }}
            placement="bottom"
            contentWrapperStyle={{ height: '100%', boxShadow: 'unset' }}
            maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}
            visible={true}
            className="drawer-element-body no-padding no-border-radius"
            onClose={onClose}
        >
            {isLink ? (
                <iframe
                    name={eleId}
                    allowFullScreen={true}
                    src={link}
                    style={{ border: 0, width: '100%', height: '100%' }}
                    onLoad={() => {
                        // 获取iframe标签并监听链接变化
                        const iframe = document.querySelector(`iframe[name="${eleId}"]`) as HTMLIFrameElement;
                        if (iframe) {
                            const iframeWindow = iframe.contentWindow;
                            const title = iframeWindow?.document.title;
                            if (!config?.title && !hideTitle) {
                                const titleEle = document.getElementById(`${eleId}Title`) as HTMLDivElement;
                                if (titleEle) {
                                    titleEle.innerText = title || '';
                                }
                            }
                        }
                    }}
                />
            ) : (
                content
            )}
        </Drawer>,
    );
    return {
        eleId,
        onClose,
    };
};
